import { Phase } from '@/features/orders/constants/app'
import { MenuBadgeSlotProps, MenuItemBadge } from '@/features/ui/navigation'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { FC, memo } from 'react'

const OrdersDrawerBadge: FC<MenuBadgeSlotProps> = ({ active, ...props }) => {
    const countReady = useAppSelector(ordersSelectors.isOrdersLoaded)
    const countNew = useAppSelector(ordersSelectors.countByPhase(Phase.New))

    if (!countReady) return null

    return <MenuItemBadge inverted={!active} {...props} count={countNew} />
}

export default memo(OrdersDrawerBadge)
